import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { createElement } from "@wordpress/element";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/** @format */

/**
 * External dependencies
 */
import { Component } from '@wordpress/element';
import PropTypes from 'prop-types';
import { partial } from 'lodash';
/**
 * WooCommerce dependencies
 */

import { getHistory } from '@woocommerce/navigation';
/**
 * Use `Link` to create a link to another resource. It accepts a type to automatically
 * create wp-admin links, wc-admin links, and external links.
 */

var Link =
/*#__PURE__*/
function (_Component) {
  _inherits(Link, _Component);

  function Link() {
    _classCallCheck(this, Link);

    return _possibleConstructorReturn(this, _getPrototypeOf(Link).apply(this, arguments));
  }

  _createClass(Link, [{
    key: "wcAdminLinkHandler",
    // @todo Investigate further if we can use <Link /> directly.
    // With React Router 5+, <RouterLink /> cannot be used outside of the main <Router /> elements,
    // which seems to include components imported from @woocommerce/components. For now, we can use the history object directly.
    value: function wcAdminLinkHandler(onClick, event) {
      event.preventDefault(); // If there is an onclick event, execute it.

      var onClickResult = onClick ? onClick(event) : true; // Mimic browser behavior and only continue if onClickResult is not explicitly false.

      if (onClickResult === false) {
        return;
      }

      getHistory().push(event.target.closest('a').getAttribute('href'));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          href = _this$props.href,
          type = _this$props.type,
          props = _objectWithoutProperties(_this$props, ["children", "href", "type"]);

      var passProps = _objectSpread({}, props, {
        'data-link-type': type
      });

      if ('wc-admin' === type) {
        passProps.onClick = partial(this.wcAdminLinkHandler, passProps.onClick);
      }

      return createElement("a", _extends({
        href: href
      }, passProps), children);
    }
  }]);

  return Link;
}(Component);

Link.propTypes = {
  /**
   * The resource to link to.
   */
  href: PropTypes.string.isRequired,

  /**
   * Type of link. For wp-admin and wc-admin, the correct prefix is appended.
   */
  type: PropTypes.oneOf(['wp-admin', 'wc-admin', 'external']).isRequired
};
Link.defaultProps = {
  type: 'wc-admin'
};
Link.contextTypes = {
  router: PropTypes.object
};
export default Link;
//# sourceMappingURL=index.js.map